import { DatesUnit } from "@ryde/shared";

/**
 * Stable key for the rides search: which view, over which date range, plus the id-search refetch token.
 *
 * A primitive so an atom write producing an equal range compares equal and does not refetch. Note
 * `changeCalendarDates` already preserves the object for an equal range, but two writers bypass it -
 * the global ride-id search and its clear-up - so the value comparison still earns its place here.
 *
 * The token covers the id-scoped navigations, whose range is frequently the one already shown - see
 * `ridesIdSearchRefetchTokenAtom`.
 */
export const buildRidesFetchKey = ({
  activeViewId,
  calendarDates,
  idSearchRefetchToken,
}: {
  activeViewId: number | undefined;
  calendarDates: DatesUnit | undefined;
  idSearchRefetchToken: number;
}): string =>
  `${activeViewId ?? ""}|${calendarDates?.date1 ?? ""}|${calendarDates?.date2 ?? ""}|${idSearchRefetchToken}`;
